module.exports = __webpack_public_path__ + "img/ic_wxpay.2991a78e.png";